import ThemeContext from './ThemeContext';

export default ThemeContext;
export * from './ThemeContext';
